import {AxiosInstance, AxiosResponse} from "axios";
import {Department} from "@/core/interfaces/City";

/**
 * The version resource.
 *
 * @param {Object} client - The injected client.
 * @returns {Object} The public object.
 */
export default function (client: AxiosInstance) {
    return {
        /**
         * Tell if the version is highlighted.
         */
        async getDepartments(): Promise<Department[]> {
            return client.get("city-departments")
                .then((response: AxiosResponse) => response.data.data);
        }
    };
}